import { render, staticRenderFns } from "./KraChangeHistory.vue?vue&type=template&id=5828c723&scoped=true"
import script from "./KraChangeHistory.vue?vue&type=script&lang=js"
export * from "./KraChangeHistory.vue?vue&type=script&lang=js"
import style0 from "./KraChangeHistory.vue?vue&type=style&index=0&id=5828c723&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5828c723",
  null
  
)

export default component.exports